import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import es from '@/i18n/es';

Vue.use(Vuetify);

const opts = {
  theme: {
    themes: {
      light: {
        primary: '#C1DAB1',
        secondary: '#b0bec5',
        accent: '#8c9eff',
        error: '#E57373',
      },
    },
  },
  lang: {
    locales: { es },
    current: 'es',
  },
};

export default new Vuetify(opts);



// WEBPACK FOOTER //
// ./src/plugins/vuetify.js